<template lang="pug">
    .eventsFilters
        .filter(v-for="filter in cFilters"
            :class="{active: filter.status}"
            @click="toggleFilter(filter)") {{filter.name}}
</template>

<script>
    export default {
        name: "EventsFilters",
        methods: {
            getCheckedFilters() {
                return this.cFilters.filter(el => el.status);
            },
            toggleFilter(filter) {
                this.$store.commit("changeFilterStatus", filter)
                this.$emit('input', this.getCheckedFilters().map(el => el.name))
            },
            checkTagFromUrl() {
                if (this.$route.query.tag) {
                    this.clearFilters();
                    let filter = this.cFilters.find(f => f.name === this.$route.query.tag);
                    if (!filter) return;
                    this.toggleFilter(filter);
                }
            },
            clearFilters(){
                this.cFilters.forEach(f=>{
                    if (f.status){
                        this.toggleFilter(f);
                    }
                })
            }
        },
        watch: {
            $route() {
                this.checkTagFromUrl();
            }
        },
        beforeMount() {
            this.checkTagFromUrl();
        },
        mounted() {
            this.$emit('input', this.getCheckedFilters().map(el => el.name));
        },
        computed: {
            cFilters() {
                return this.$store.state.tags
            }
        }
    }
</script>

<style scoped lang="scss">

    .eventsFilters {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        width: 71%;

        .filter {
            /*margin: 0 1.7rem 0.5rem;*/
            width: 20%;
            margin: 0.7rem 0;
            display: flex;
            align-items: center;
            font-size: 1.25rem;
            color: $grey;
            cursor: pointer;
            transition: .2s;

            &:before {
                content: '';
                display: block;
                width: to_rem(6px);
                height: to_rem(6px);
                margin-right: 0.5rem;
                border: to_rem(6px) solid $grey;
                border-radius: 50%;
                transition: .2s;
            }

            &.active {
                color: #000;

                &:before {
                    border-color: $red
                }
            }
        }

        @include razr1600 {
            /*justify-content: flex-start;*/
            width: 67%;
            margin-left: 13vw;
            .filter {
                margin: 0.7rem 0;
            }
        }
        @include razr1240 {
            /*justify-content: flex-start;*/
            width: 96%;
            margin-left: 2vw;
            .filter {
                margin: 0.7rem 0;
            }
        }

        @include mobile_or_P {
            justify-content: center;
            .filter {
                width: 35%;
                margin: 0 1rem 1.4rem;
                font-size: 0.95rem;

                &:before {
                    width: 0.3rem;
                    height: 0.3rem;
                    border-width: 0.3rem;
                }
            }
        }
    }
</style>
